// extracted by mini-css-extract-plugin
export var button = "_1f-0";
export var buttonContent = "_1f-e";
export var buttonGroup = "_1f-c";
export var dontRestrainIconWidth = "_1f-a";
export var dropdownButton = "_1f-b";
export var iconContainer = "_1f-9";
export var lg = "_1f-4";
export var md = "_1f-3";
export var pending = "_1f-f";
export var sm = "_1f-2";
export var spinner = "_1f-d";
export var squared = "_1f-8";
export var wrapText = "_1f-g";
export var xl = "_1f-5";
export var xs = "_1f-1";
export var xxl = "_1f-6";
export var xxxl = "_1f-7";